import { render } from "./cambioAuditoria.vue?vue&type=template&id=70b84dc4&scoped=true"
import script from "./cambioAuditoria.vue?vue&type=script&lang=js"
export * from "./cambioAuditoria.vue?vue&type=script&lang=js"

import "./cambioAuditoria.vue?vue&type=style&index=0&id=70b84dc4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b84dc4"]])

export default __exports__